<section id="section-borrower-testimonials" class="row grey-section" #borrowerTestimonials>
  <div class="row">
    <h2 class="heading col-xs-10 col-xs-offset-1">What our Customers Say</h2>
  </div>

  <div class="row">
    <p class="subheading col-xs-10 col-xs-offset-1 col-md-8 col-md-offset-2">
      Here are some dreams fulfilled
    </p>
  </div>

  <div class="row">
    <div class="col-xs-12 col-md-10 col-md-offset-1 testimonial-cards">

      <div class="testimonial-card">
        <div class="header">
          <img class="img-responsive img-circle testimonial-card-image"
               alt="Uma Maheshwari, a borrower with finzy"
               src="../../../../assets/images/borrower-testimonials/uma-maheshwari.png">
          <div class="display-inline">
            <span class="name">Uma Maheshwari</span>
            <br/>
            <span class="location">Bangalore</span>
          </div>
        </div>

        <div class="review">
          "On sharing my requirement, I got a loan of ₹5 Lacs from finzy in 2 working days. I used it for doing up the
          interiors of my flat."
        </div>
      </div>

      <div class="testimonial-card">
        <div class="header">
          <img class="img-responsive img-circle testimonial-card-image"
               alt="Bikram Chatterjee, a borrower with finzy"
               src="../../../../assets/images/borrower-testimonials/bikram-chatterjee.png">
          <div class="display-inline">
            <span class="name">Bikram Chatterjee</span>
            <br/>
            <span class="location">Bangalore</span>
          </div>
        </div>

        <div class="review">
          "It’s an absolutely brilliant venture! The process is completely hassle free and you are treated like the most
          important person in the world. I was completely awestruck with the process and the experience. Thanks finzy
          for making me independent and helping me live my dream!"
        </div>
      </div>

      <div class="testimonial-card">
        <div class="header">
          <img class="img-responsive img-circle testimonial-card-image"
               alt="L Giri Naidu, a borrower with finzy"
               src="../../../../assets/images/borrower-testimonials/l-giri-naidu.png">
          <div class="display-inline">
            <span class="name">L Giri Naidu</span>
            <br/>
            <span class="location">Bangalore</span>
          </div>
        </div>

        <div class="review">
          "What impressed me the most was finzy’s online process of self uploading basic documents, which made me feel
          safe and comfortable. All in all the entire process was fast, safe and convenient."
        </div>
      </div>

    </div>
  </div>
</section>
